module.exports = __webpack_public_path__ + "static/assets/8e036db06d9a3662ed9f34a4d9a55da5.svg";